import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { publicURL } from 'utils/axiosInstance';
import { HIDE_COOKIE_BANNER_STORAGE_KEY } from '../CookiePoliciesBanner/CookiePoliciesBanner';
import './InterhomeSuccessfulPayment.scss';

function InterhomeSuccessfulPayment() {
  const { bookingReference } = useParams<{ bookingReference: string }>();

  useEffect(() => {
    sessionStorage.setItem('InterhomeSuccessfulPayment', bookingReference);
    sessionStorage.setItem(HIDE_COOKIE_BANNER_STORAGE_KEY, 'false');
  }, []);

  return (
    <div className="interhome-successful-payment">
      <div className="message">
        <div className="title">Success!!</div>
        <div className="text">please close the pop-up window to continue...</div>
      </div>
      <div className="icon-container">
        <div className="urbain-icon">
          <img src={`${publicURL}/images/interstitialPanel/Urbain-Logo-Interstitial.png`} alt="urbain_logo" />
        </div>
        <div className="icon">
          <img src={`${publicURL}/images/interstitialPanel/Interhome-logo-interstitial.png`} alt="interhome_logo" />
        </div>
      </div>
    </div>
  );
}
export default InterhomeSuccessfulPayment;
